'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SvgContainer = require('./SvgContainer');

var _SvgContainer2 = _interopRequireDefault(_SvgContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalculatorOutline = function CalculatorOutline(props) {
  return _react2.default.createElement(
    _SvgContainer2.default,
    {
      height: props.height,
      width: props.width,
      color: props.color,
      onClick: props.onClick,
      rotate: props.rotate ? 1 : 0,
      shake: props.shake ? 1 : 0,
      beat: props.beat ? 1 : 0,
      className: props.className
    },
    _react2.default.createElement(
      'svg',
      { style: props.style, className: props.cssClasses, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512 512' },
      props.title ? _react2.default.createElement(
        'title',
        null,
        props.title
      ) : '',
      _react2.default.createElement('rect', { x: '112', y: '48', width: '288', height: '416', rx: '32', ry: '32', fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32' }),
      _react2.default.createElement('path', { fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M160.01 112H352v64H160.01z' }),
      _react2.default.createElement('circle', { cx: '168', cy: '248', r: '24' }),
      _react2.default.createElement('circle', { cx: '256', cy: '248', r: '24' }),
      _react2.default.createElement('circle', { cx: '344', cy: '248', r: '24' }),
      _react2.default.createElement('circle', { cx: '168', cy: '328', r: '24' }),
      _react2.default.createElement('circle', { cx: '256', cy: '328', r: '24' }),
      _react2.default.createElement('circle', { cx: '168', cy: '408', r: '24' }),
      _react2.default.createElement('circle', { cx: '256', cy: '408', r: '24' }),
      _react2.default.createElement('rect', { x: '320', y: '304', width: '48', height: '128', rx: '24', ry: '24' })
    )
  );
};

CalculatorOutline.defaultProps = {
  // style
  style: {},
  color: '#000000',
  height: '22px',
  width: '22px',
  cssClasses: '',
  title: '',

  // animation
  shake: false,
  beat: false,
  rotate: false
};

CalculatorOutline.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  cssClasses: _propTypes2.default.string,
  title: _propTypes2.default.string,

  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,

  // functions
  onClick: _propTypes2.default.func
};

exports.default = CalculatorOutline;
module.exports = exports['default'];
//# sourceMappingURL=CalculatorOutline.js.map